import { render } from "./cloudflare-dns-zones.vue?vue&type=template&id=1e9c8290&scoped=true"
import script from "./cloudflare-dns-zones.vue?vue&type=script&lang=js"
export * from "./cloudflare-dns-zones.vue?vue&type=script&lang=js"

import "./cloudflare-dns-zones.vue?vue&type=style&index=0&id=1e9c8290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9c8290"]])

export default __exports__